import React, { Component } from "react";
import InputMask from "react-input-mask";

class CadastroEndereco extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div style={this.props.styleInativo} className="card">
            <div className="card-body">
              <h4 className="card-title">ENDEREÇO</h4>
              <div className="form-group row">
                <div className="col-md-3">
                  <label>Estado</label>
                  <input
                    readOnly
                    placeholder="ESTADO"
                    type="text"
                    name="estado"
                    className="form-control"
                    value={this.props.value.estado}
                    onChange={this.props.onChange}
                  />
                </div>
                <div className="col-md-3">
                  <label>Cidade</label>
                  <select
                    name="cidade"
                    className="form-control"
                    value={this.props.value.cidade}
                    onChange={this.props.onChange}
                  >
                    <option value={"ALVORADA DO SUL"}>ALVORADA DO SUL</option>
                    <option value={"ASSAI"}>ASSAI</option>
                    <option value={"BELA VISTA DO PARAISO"}>BELA VISTA DO PARAISO</option>
                    <option value={"CAFEARA"}>CAFEARA</option>
                    <option value={"CAMBE"}>CAMBE</option>
                    <option value={"CENTENÁRIO DO SUL"}>CENTENÁRIO DO SUL</option>
                    <option value={"FLORESTOPOLIS"}>FLORESTOPOLIS</option>
                    <option value={"GUARACI"}>GUARACI</option>
                    <option value={"IBIPORA"}>IBIPORA</option>
                    <option value={"JAGUAPITA"}>JAGUAPITA</option>
                    <option value={"JATAIZINHO"}>JATAIZINHO</option>
                    <option value={"LONDRINA"}>LONDRINA</option>
                    <option value={"LUPIONOPOLIS"}>LUPIONOPOLIS</option>
                    <option value={"MIRASELVA"}>MIRASELVA</option>
                    <option value={"PITANGUEIRAS"}>PITANGUEIRAS</option>
                    <option value={"PORECATU"}>PORECATU</option>
                    <option value={"PRADO FERREIRA"}>PRADO FERREIRA</option>
                    <option value={"PRIMEIRO DE MAIO"}>PRIMEIRO DE MAIO</option>
                    <option value={"ROLANDIA"}>ROLANDIA</option>
                    <option value={"SERTANOPOLIS"}>SERTANOPOLIS</option>
                    <option value={"TAMARANA"}>TAMARANA</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label>Logradouro</label>
                  <input
                    placeholder="LOGRADOURO"
                    type="text"
                    name="logradouro"
                    className="form-control"
                    value={this.props.value.logradouro}
                    onChange={this.props.onChange}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-3">
                  <label>Número</label>
                  <input
                    placeholder="NÚMERO"
                    type="text"
                    name="numero"
                    className="form-control"
                    value={this.props.value.numero}
                    onChange={this.props.onChange}
                  />
                </div>
                <div className="col-md-3">
                  <label>CEP</label>
                  <InputMask
                    placeholder="CEP"
                    type="text"
                    name="cep"
                    mask="99.999-999"
                    className="form-control"
                    value={this.props.value.cep}
                    onChange={this.props.onChange}
                  />
                </div>
                <div className="col-md-6">
                  <label>Bairro</label>
                  <input
                    placeholder="BAIRRO"
                    type="text"
                    name="bairro"
                    className="form-control"
                    value={this.props.value.bairro}
                    onChange={this.props.onChange}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-6">
                  <label>Complemento</label>
                  <input
                    placeholder="COMPLEMENTO"
                    type="text"
                    name="complemento"
                    className="form-control"
                    value={this.props.value.complemento}
                    onChange={this.props.onChange}
                  />
                </div>
                <div className="col-md-6">
                  <label>Ponto de Referência</label>
                  <input
                    placeholder="PONTO DE REFERENCIA"
                    type="text"
                    name="pontoReferencia"
                    className="form-control"
                    value={this.props.value.pontoReferencia}
                    onChange={this.props.onChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CadastroEndereco;
